import React, { useCallback, useEffect, useMemo, useState } from 'react';
import '@ant-design/compatible/assets/index.css';
import moment from 'moment';
import {
  Form,
  Tabs,
  Col,
  Input,
  Row,
  Typography,
  Spin,
  Checkbox,
  Divider,
  DatePicker,
  Collapse,
  notification,
  message,
  Button,
} from 'antd';
import DF from 'DisplayFramework';
import Text from 'components/Text';
import { toCurrency, toRate } from 'utils/utils';
import { dateToString } from 'utils/utils2';
import DataGrid from 'components/DataGrid';
import { DataGridColDef } from 'components/DataGrid/DataGrid';
import {
  calculatePrefinInterestByContractElement,
  getFinContractPrefinElementList,
} from 'services/clientInvoice';
import ParListSelect from 'components/ParListSelect';
import { CaretRightOutlined } from '@ant-design/icons';
import { Text as Textc } from '@react-pdf/renderer';
import GetLabel from 'DisplayFramework/components/GetLabel';
import { getFinContractById } from 'services/fincontract';
import { groupBy } from 'lodash';
import * as finEngine from 'services/finEngine';
import ICalculator from 'icons/ICalculator';

const { TabPane } = Tabs;
const { Text: AntText } = Typography;
const { Panel } = Collapse;

const TabPrefinActivation = (props: any) => {
  const [state, setState] = useState<any>({
    calStatusColor: 'red',
    currcode: '',
    finConElemSteps: [],
    selectedRowKeys: [],
    partamountinit: 0,
    deferredinterestlabel: '',
    SERV: [],
    FEES: [],
    COMM: [],
    FINSERV: [],
    ElementFIN: [],
    rentalamountinit: 0,
    rentalamount: 0,
    investamountinit: 0,
    investamount: 0,
    upfrontamountinit: 0,
    upfrontamount: 0,
    finamountinit: 0,
    finamount: 0,
    billingdateinit: 1,
    ctebillingdate: 1,
    deferredinterestamount: 0,
    ctedeferredinterestmethod: '',
    ctedeferredinterestnominalrate: 0,
    ctedepositamountinit: 0,
    ctedepositamountused: 0,
    ctedepositamount: 0,
    ctedepositinterestmethod: '',
    ctedepositnominalrate: 0,
    firstrentalinit: 0,
    firstrentalcoef: 0,
    firstrentalamount: 0,
    residualvalueinit: 0,
    residualvalue: 0,
    rvcoef: 0,
    disbursmentinit: 0,
    disbursment: 0,
    commissioninit: 0,
    commission: 0,
    term: '',
    ratetype: '',
    rate: 0,
    rateperiodicity: '',
    periodicity: '',
    unit: '',
    duration: 0,
    durationlabel: '',
    interestmethod: '',
    gpduration: 0,
    gpmethod: '',
    ctepartmethod: '',
    cteid: 0,
    ctepartrate: 0,
    ctepartnbdays: 0,
    partamountused: 0,
    partamount: 0,
    taxtype: 'RENTAL',
    taxcode: 'NORM',
    taxrate: 20,
    PrefinElements: [],
    activationdate: '',
  });
  const [load, setload] = useState(false);

  const initValues = useCallback(() => {
    props.form.setFieldsValue({
      calculationStatus: false,
      invoiceParticipation: 'true',
      invoiceUpfront: 'true',
      invoiceDeferredinterest: 'true',
      invoiceDeposit: 'true',
      invoiceFirstrental: 'true',
    });
  }, [props.form]);

  const updateState = useCallback(
    (values) => {
      setState((prev: any) => ({ ...prev, ...values }));
    },
    [setState]
  );

  const loadPrefinEle = useCallback(
    (ctrid) => {
      setload(true);
      props.setSuccessful(true);

      getFinContractById({ ctrid }).then((response) => {
        const proposal = response.data;
        if (response.data) {
          const {
            SERV = [],
            FEES = [],
            COMM = [],
            FINSERV = [],
          } = groupBy(proposal.conElements, 'ctetype');
          const elemFin = proposal.conElements.filter(
            (e) => e.ctetype === 'FIN'
          );
          updateState({
            SERV: SERV,
            FEES: FEES,
            COMM: COMM,
            FINSERV: FINSERV,
            ElementFIN: elemFin,
          });
          initValues();
          props.setSuccessful(false);

          getFinContractPrefinElementList({ ctrid })
            .then((response) => {
              updateState({
                PrefinElements: response.list,
              });
              setload(false);
              props.setSuccessful(false);
            })
            .catch(() =>
              //handle error
              {
                setload(false);
                props.setSuccessful(false);
              }
            );
        }
      });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [initValues, props.form, updateState]
  );
  const columnsconE = useMemo<DataGridColDef<any>[]>(
    () => [
      {
        comcode: 'Element.ctetypelabel',
        dataIndex: 'servtypelabel',
        width: '20%',
        render: (value, record) =>
          record.serviceResponse?.servtypelabel ??
          record.commissionResponse?.commtypelabel,
      },
      {
        comcode: 'Element.servcategorylabel',
        dataIndex: 'servtypelabel',
        width: '20%',
        render: (value, record) =>
          record.serviceResponse?.servcategorylabel ?? record.ctecategory,
      },

      {
        comcode: 'Element.ctedescription',
        dataIndex: 'ctedescription',
        width: '30%',
      },
      {
        comcode: 'Element.tpname',
        dataIndex: 'tpname',
        width: '20%',
        render: (value, record) =>
          record.serviceResponse?.tpname ??
          record.commissionResponse?.commlabel,
      },
      {
        comcode: 'Element.servbasislabel',
        dataIndex: 'servbasislabel',
        width: '20%',
        render: (value, record) =>
          record.serviceResponse?.servbasislabel ??
          record.commissionResponse?.commbasislabel,
      },

      {
        comcode: 'Element.servcalculationmethodlabel',
        dataIndex: 'servcalculationmethodlabel',
        width: '35%',
        render: (value, record) =>
          record.serviceResponse?.servcalculationmethodlabel ??
          record.commissionResponse?.commcalculationmethodlabel,
      },

      {
        comcode: 'Element.servdurationlabel',
        dataIndex: 'servdurationlabel',
        width: '40%',
        render: (value, record) =>
          record.serviceResponse?.servdurationlabel ??
          record.commissionResponse?.commdurationlabel,
      },

      {
        comcode: 'Element.flagfollowgraceperiod',
        dataIndex: 'flagfollowgraceperiod',
        width: '20%',
        render: (value, record) => (
          <Textc>{String(record.pricing?.flagfollowgraceperiod)}</Textc>
        ),
      },

      {
        comcode: 'Element.flagmandatory',
        dataIndex: 'flagmandatory',
        width: '20%',
        render: (value, record) => (
          <Textc>{String(record.pricing?.flagmandatory)}</Textc>
        ),
      },
      {
        comcode: 'Element.flagupdate',
        dataIndex: 'flagupdate',
        width: '20%',
        render: (value, record) => (
          <Textc>{String(record.pricing?.flagupdate)}</Textc>
        ),
      },
      {
        comcode: 'Element.allowfinservice',
        dataIndex: 'allowfinservice',
        width: '20%',
        render: (value, record) => (
          <Textc>{String(record.pricing?.allowfinservice)}</Textc>
        ),
      },

      {
        comcode: 'Element.ctenominalrate',
        dataIndex: 'ctenominalrate',
        render: toRate,
        width: '20%',
      },
      {
        comcode: 'Element.cteinstallmentamount',
        dataIndex: 'cteinstallmentamount',
        render: (val, record) => toCurrency(val, record?.currcode),
        fixed: 'right',
        width: '20%',
        align: 'right',
      },
    ],
    []
  );
  const columns: DataGridColDef<any>[] = [
    {
      dataIndex: 'cteorder',
      width: '100px',
    },
    {
      dataIndex: 'ctedescription',
      fixed: 'left',
      width: '130px',
    },
    {
      dataIndex: 'ctefinancedamount',
      width: '130px',
      align: 'right',
      render: (val, record) => toCurrency(val, record.curcode),
    },
    {
      dataIndex: 'totalDisbursed',
      width: '130px',
      align: 'right',

      render: (val, record) => toCurrency(val, record.curcode),
    },
    {
      dataIndex: 'prefinbasislabel',
      width: '150px',
    },
    {
      dataIndex: 'prefinmethodlabel',
      width: '150px',
    },
    {
      dataIndex: 'totalInterestCalculated',
      width: '150px',
      align: 'right',

      render: (val, record) => toCurrency(val, record.curcode),
    },
    {
      dataIndex: 'lastCalDate',
      width: '130px',
    },
    {
      dataIndex: 'totalInvoiced',
      width: '130px',
      align: 'right',

      render: (val, record) => toCurrency(val, record.curcode),
    },
  ];

  const onChangeBilldate = (value: any) => {
    let elem = state.ElementFIN;

    calculate2(
      'INST',
      state.finamount,
      elem.ctepaymentterm,
      elem.cteinterestmethod,
      elem.ctenominalrate,
      elem.cterateperiodicity,
      elem.cteratetype,
      elem.cteunit,
      elem.cteperiodicity,
      elem.cteduration,
      state.residualvalue,
      elem.cteinstallmentamount,
      elem.cteratebasis,
      2,
      9,
      state.firstrentalamount,
      elem.ctegraceperiodduration,
      elem.ctegraceperiodmethod,
      value,
      elem.ctedeferredinterestmethod,
      elem.ctedeferredinterestnominalrate,
      elem.ctedepositinterestmethod,
      elem.ctedepositamount,
      elem.ctedepositnominalrate,
      elem.ctepartmethod,
      elem.ctepartamount,
      elem.ctepartrate,
      elem.ctepartnbdays,
      state.startdate,
      'RENTAL',
      elem.taxcode,
      0,
      state.upfrontamount
    );
  };

  const toDateString = (momentOrString: any) =>
    momentOrString === undefined
      ? ''
      : typeof momentOrString === 'string'
      ? momentOrString
      : momentOrString.format('YYYY-MM-DD');
  const calculatePreFin = (
    ctrid: any,
    cteid: any,
    activationdate: any,
    mode: any
  ) => {
    calculatePrefinInterestByContractElement({
      activationDate: activationdate,
      ctreid: Number(cteid),
      ctrid: Number(ctrid),
      mode: String(mode),
    }).then((res) => {
      if (res.code === '200')
        props.form.setFieldsValue({
          calculationStatus: true,
        });
      else
        props.form.setFieldsValue({
          calculationStatus: false,
        });
    });
  };
  const calculate2 = (
    method: any,
    finamount: any,
    term: any,
    interestMethod: any,
    rate: any,
    ratePeriodicity: any,
    rateType: any,
    unit: any,
    periodicity: any,
    duration: any,
    RVAmount: any,
    installment: any,
    basis: any,
    rounding: any,
    roundingrate: any,
    firstrentalamount: any,
    gpduration: any,
    gpmethod: any,
    ctbillingdate: any,
    ctedeferredinterestmethod: any,
    ctedeferredinterestnominalrate: any,
    ctedepositinterestmethod: any,
    ctedepositamount: any,
    ctedepositnominalrate: any,
    ctepartmethod: any,
    ctepartamount: any,
    ctepartrate: any,
    ctepartnbdays: any,
    ctinitstartdate: any,
    taxtype: any,
    taxcode: any,
    taxrate: any,
    upfrontamount: any
  ) => {
    finEngine
      .calculate({
        finReq: {
          inBillingDate: ctbillingdate,
          inCalculationMethod: method,
          inCalculationType:"LINEAR",
          inCountingbasis: basis,
          inDeferredMethod: ctedeferredinterestmethod,
          inDeferredRate: ctedeferredinterestnominalrate,
          inDepositAmount: ctedepositamount,
          inDepositMethod: ctedepositinterestmethod,
          inDepositRate: 0,
          inDuration: duration,
          inFinancedAmount: finamount,
          inFirstInstallmentDate: '',
          inFirstPayment: firstrentalamount,
          inGracePeriodDuration: gpduration,
          inGracePeriodMethod: gpmethod,
          inInstallmentAmount: installment,
          inInterestMethod: interestMethod,
          inPartAmount: ctepartamount,
          inPartMethod: ctepartmethod,
          inPartNbDays: ctepartnbdays,
          inPartRate: ctepartrate,
          inPeriodicity: periodicity,
          inPeriodicityUnit: unit,
          inRatePeriodicity: ratePeriodicity,
          inRateType: rateType,
          inRateValue: rate,
          inResidualValue: RVAmount,
          inRoundingAmount: rounding,
          inRoundingRate: roundingrate,
          inStartDate: toDateString(ctinitstartdate),
          inTaxcode: taxcode,
          inTaxrate: taxrate,
          inTaxtype: taxtype,
          inTerm: term,
          inUpFrontAmount: upfrontamount,
        },
      })
      .then((response) => {
        if (response.success === false) {
          notification.error({
            message: response.message,
            duration: 0,
          });
        } else {
          const calculations = response;
          const partAmount =
            ctepartmethod === 'PROMO' || ctepartmethod === 'REDUCEFIN'
              ? ctepartamount
              : 0;
          const upfrontAmount = upfrontamount;

          const investAmount = finamount + upfrontAmount + partAmount;

          props.form.setFieldsValue({
            investAmount: investAmount,

            finAmount: calculations.financedamount,
            residualValue: calculations.residualvalue,

            ctduration: calculations.duration,
          });

          updateState({
            deferredinterestamount: calculations.deferredInterest,
            residualvalue: calculations.residualvalue,
            duration: calculations.duration,
            finamount: calculations.financedamount,
            rentalamount:
              calculations.installmentamount - calculations.depositInterest,
          });

          const elemFin = state.ElementFIN;
          elemFin.cteinstallmentamount = calculations.installmentamount;
          elemFin.ctedeferredinterest = calculations.deferredInterest;
          elemFin.ctedepositinterest = calculations.depositInterest;
          elemFin.cterentalamount =
            calculations.installmentamount - calculations.depositInterest;
          elemFin.ctedeferredinterestmethod = ctedeferredinterestmethod;
          elemFin.ctedeferredinterestnominalrate =
            ctedeferredinterestnominalrate;
          elemFin.ctedepositamount = ctedepositamount;
          elemFin.ctedepositinterestmethod = ctedepositinterestmethod;
          elemFin.ctedepositnominalrate = ctedepositnominalrate;
          elemFin.ctepartmethod = ctepartmethod;
          elemFin.ctepartamount = ctepartamount;
          elemFin.ctepartrate = ctepartrate;
          elemFin.ctepartnbdays = ctepartnbdays;
          elemFin.taxcode = taxcode;
          elemFin.cteupfrontamount = state.upfront;
          elemFin.cteinvestamount = state.investamount;
          elemFin.ctenominalrate = calculations.nominalrate;
          elemFin.cteactuarialrate = calculations.effectiverate;
          elemFin.ctervamount = calculations.residualvalue;
          elemFin.ctervcoef =
            (calculations.residualvalue / calculations.financedamount) * 100;
          elemFin.ctefirstpayment = calculations.inFirstPayment;
          elemFin.ctefirstpaymentcoef =
            (calculations.inFirstPayment / calculations.financedamount) * 100;
          elemFin.cteduration = calculations.duration;
          elemFin.cteunit = unit;
          elemFin.ctefinancedamount = calculations.financedamount;
          elemFin.conElemSchedules = calculations.paymentSchedule;
          updateState({
            ElementFIN: [elemFin],
          });
          //message.success(calculations.message);
        }
      })
      .catch((err) => {
        message.error(
          'Error in calculation. please contact the service provider'
        );
      });
  };

  const rowSelection = {
    onChange: (selectedRowKeys: any, selectedRows: any) => {
      const selectedElem = selectedRows[0];
      const allFinElements: any[] = state.ElementFIN ?? [];
      const element = allFinElements?.filter(
        (ele: any) => ele.cteid === selectedElem.cteid
      )[0];

      updateState({
        cteid: selectedElem.cteid,
        investamountinit: element.cteinvestamount,
        investamount:
          selectedElem.totalDisbursed +
          selectedElem.totalInterestCalculated -
          selectedElem.totalInvoiced,
        upfrontamountinit: element.cteupfrontamount,
        upfrontamount: element.cteupfrontamount,
        partamountinit: element.ctepartamount,
        partamount: element.ctepartamount,
        finamountinit: selectedElem.ctefinancedamount,
        finamount:
          selectedElem.totalDisbursed +
          selectedElem.totalInterestCalculated -
          selectedElem.totalInvoiced -
          element.ctepartamount -
          element.cteupfrontamount,
        billingdateinit: element.ctebilligdate,
        deferredinterestlabel: element.ctedeferredinterestmethodlabel,
        deferredinterestamount: element.ctedeferredinterest,
        ctedepositamountinit: element.ctedepositamount,
        rentalamount: element.cterentalamount,
        rentalamountinit: element.cterentalamount,
        residualvalueinit: element.ctervamount,
        residualvalue: element.ctervamount,
        finConElemSteps: element?.finConElemSteps ?? [],
        activationdate:
          moment(new Date()) < moment(selectedElem.lastCalDate)
            ? null
            : moment(new Date()),
      });
      props.form.setFieldsValue({
        lastCalDate: moment(selectedElem.lastCalDate),
        activationdate:
          moment(new Date()) < moment(selectedElem.lastCalDate)
            ? null
            : moment(new Date()),
      });
    },
  };

  useEffect(() => {
    loadPrefinEle(props.objectid);
  }, [loadPrefinEle, props.objectid]);

  return (
    <DF.Provider pagcode="tabPrefinActivation">
      <Spin spinning={load}>
        <Tabs animated defaultActiveKey="1">
          <TabPane tab="Asset" key={1} forceRender>
            <DataGrid
              size="small"
              scroll={{ x: 1000, y: 400 }}
              pagination={{ pageSize: 10 }}
              rowSelection={{
                type: 'radio',
                ...rowSelection,
              }}
              dataSource={state.PrefinElements}
              rowKey={(record) => record.cteid}
              columns={columns}
            />
            <Row>
              <Col span={2}>Activation Date :</Col>
              <Col span={4}>
                <Form.Item
                  style={{ marginLeft: 15 }}
                  name="activationDate"
                  rules={[
                    {
                      required: true,
                      message: 'activationDate is mandatory',
                    },
                    ({ getFieldValue }) => ({
                      validator(_, value) {
                        if (
                          value < getFieldValue('lastCalDate') &&
                          value !== undefined
                        ) {
                          return Promise.reject({
                            message: 'activationDate must be >= lastCalDate',
                          });
                        } else return Promise.resolve();
                      },
                    }),
                  ]}
                >
                  <DatePicker
                    onChange={(e) => {
                      updateState({ activationdate: moment(e) });
                      props.form.setFieldsValue({ calculationStatus: false });
                    }}
                  />
                </Form.Item>
              </Col>
              <Col span={5}>
                <AntText type="danger" strong>
                  New InvestAmount : {toCurrency(state.investamount,state.currcode)}
                </AntText>
              </Col>
              <Form.Item
                style={{ marginLeft: 15 }}
                name="calculationStatus"
                rules={[
                  {
                    required: true,
                  },
                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      if (value === false) {
                        return Promise.reject({
                          message: 'calculationStatus is not valid!',
                        });
                      }
                      return Promise.resolve();
                    },
                  }),
                ]}
              >
                <Button
                  type="default"
                  icon={<ICalculator color={state.calStatusColor} />}
                  size="middle"
                  onClick={() =>
                    calculatePreFin(
                      props.objectid,
                      state.cteid,
                      dateToString(state.activationdate),
                      'CALCUL'
                    )
                  }
                />
              </Form.Item>
            </Row>
          </TabPane>
          <TabPane
            tab="PreFinancial activation"
            key={3}
            forceRender
            disabled={!props.form.getFieldValue('calculationStatus')}
          >
            <Row
              gutter={[8, 8]}
              style={{ fontWeight: 'bolder', fontSize: '15px' }}
            >
              <Col span={8}>
                <Text comcode="finattribute" />
              </Col>
              <Col span={4}>
                <Text comcode="initial" />
              </Col>
              <Col span={4}></Col>

              <Col span={3}>
                <Text comcode="toActivate" />
              </Col>
              <Col span={5} />
            </Row>
            <Divider style={{ marginTop: '5px', marginBottom: '5px' }} />

            <Row gutter={[8, 8]}>
              <Col span={8}>
                <Text comcode="InvestAmount" />
              </Col>
              <Col span={4}>
                <AntText>
                  {toCurrency(state.investamountinit, state.currcode)}
                </AntText>
              </Col>
              <Col span={4}></Col>
              <Col span={3}>
                <AntText>
                  {toCurrency(state.investamount, state.currcode)}
                </AntText>
              </Col>
            </Row>
            <Divider style={{ marginTop: '5px', marginBottom: '5px' }} />
            <Row gutter={[8, 8]}>
              <Col span={8}>
                <Text comcode="upfrontamount" />
              </Col>
              <Col span={4}>
                <AntText>
                  {toCurrency(state.upfrontamountinit, state.currcode)}
                </AntText>
              </Col>
              <Col span={4}></Col>
              <Col span={3}>
                <Form.Item style={{ margin: 0 }} name="upfrontamount">
                  <Input />
                </Form.Item>
              </Col>
              <Col span={5}>
                <Form.Item style={{ margin: 0 }} name="invoiceUpfront">
                  <Checkbox defaultChecked>
                    <Text comcode="flagupfront" />
                  </Checkbox>
                </Form.Item>
              </Col>
            </Row>
            <Divider style={{ marginTop: '5px', marginBottom: '5px' }} />

            <Row gutter={[8, 8]}>
              <Col span={8}>
                <Text comcode="partamount" />
              </Col>
              <Col span={4}>
                <AntText>{toCurrency(state.partamountinit,state.currcode)}</AntText>
              </Col>
              <Col span={4}></Col>
              <Col span={3}>
                <Form.Item style={{ margin: 0 }} name="partamount">
                  <Input />
                </Form.Item>
              </Col>
              <Col span={5}>
                <Form.Item style={{ margin: 0 }} name="invoiceParticipation">
                  <Checkbox defaultChecked>
                    <Text comcode="flagpart" />
                  </Checkbox>
                </Form.Item>
              </Col>
            </Row>
            <Divider style={{ marginTop: '5px', marginBottom: '5px' }} />

            <Row gutter={[8, 8]}>
              <Col span={8}>
                <Text comcode="finamount" />
              </Col>
              <Col span={4}>
                <AntText>
                  {toCurrency(state.finamountinit, state.currcode)}
                </AntText>
              </Col>
              <Col span={4}></Col>
              <Col span={3}>
                <AntText>{toCurrency(state.finamount, state.currcode)}</AntText>
              </Col>
              <Col span={5} />
            </Row>
            <Divider style={{ marginTop: '5px', marginBottom: '5px' }} />

            <Row gutter={[8, 8]}>
              <Col span={8}>
                <Text comcode="activationdate" />
              </Col>
              <Col span={4}></Col>
              <Col span={4} />

              <DatePicker value={state.activationdate} disabled />
            </Row>
            <Divider style={{ marginTop: '5px', marginBottom: '5px' }} />

            <Row gutter={[8, 8]}>
              <Col span={8}>
                <Text comcode="billingdate" />
              </Col>
              <Col span={4}>
                <AntText>
                  {toCurrency(state.billingdateinit, state.currcode)}
                </AntText>
              </Col>
              <Col span={4} />
              <Col span={3}>
                <Form.Item style={{ margin: 0 }} name="billingDate">
                  <ParListSelect
                    parcode="BILLDATE"
                    onChange={onChangeBilldate}
                  />
                </Form.Item>
              </Col>
              <Col span={5} />
            </Row>
            <Divider style={{ marginTop: '5px', marginBottom: '5px' }} />

            <Row gutter={[8, 8]}>
              <Col span={8}>
                <Text comcode="deferredinterest" />
              </Col>
              <Col span={4}>
                <AntText>{state.deferredinterestlabel}</AntText>
              </Col>
              <Col span={4}></Col>
              <Col span={3}>
                <AntText>
                  {toCurrency(state.deferredinterestamount, state.currcode)}
                </AntText>
              </Col>
              <Col span={5}>
                <Form.Item style={{ margin: 0 }} name="invoiceDeferredinterest">
                  <Checkbox defaultChecked>
                    <Text comcode="flagdeferredinterest" />
                  </Checkbox>
                </Form.Item>
              </Col>
            </Row>
            <Divider style={{ marginTop: '5px', marginBottom: '5px' }} />

            <Row gutter={[8, 8]}>
              <Col span={8}>
                <Text comcode="deposit" />
              </Col>
              <Col span={4}>
                <AntText>
                  {toCurrency(state.ctedepositamountinit, state.currcode)}
                </AntText>
              </Col>
              <Col span={4}></Col>
              <Col span={3}>
                <Form.Item style={{ margin: 0 }} name="Depositamount">
                  <Input />
                </Form.Item>
              </Col>
              <Col span={5}>
                <Form.Item style={{ margin: 0 }} name="invoiceDeposit">
                  <Checkbox defaultChecked>
                    <Text comcode="flagdeposit" />
                  </Checkbox>
                </Form.Item>
              </Col>
            </Row>
            <Divider style={{ marginTop: '5px', marginBottom: '5px' }} />

            <Divider style={{ marginTop: '5px', marginBottom: '5px' }} />

            {state.finConElemSteps.length === 0 && (
              <Row gutter={[8, 8]}>
                <Col span={8}>
                  <Text comcode="Rental" />
                </Col>
                <Col span={4}>
                  <AntText strong>
                    {toCurrency(state.rentalamountinit, state.currcode)}
                  </AntText>
                </Col>
                <Col span={4} />
                <Col span={3}>
                  <AntText strong type="warning">
                    {toCurrency(state.rentalamount,state.currcode)}
                  </AntText>
                </Col>
                <Col span={5} />
              </Row>
            )}
            <Divider style={{ marginTop: '5px', marginBottom: '5px' }} />

            <Row gutter={[8, 8]}>
              <Col span={8}>
                <Text comcode="residualvalue" />
              </Col>
              <Col span={4}>
                <AntText strong>
                  {toCurrency(state.residualvalueinit, state.currcode)}
                </AntText>
              </Col>
              <Col span={4} />
              <Col span={3}>
                <AntText strong type="warning">
                  {toCurrency(state.residualvalue, state.currcode)}
                </AntText>
              </Col>
              <Col span={5} />
            </Row>

            {state.finConElemSteps.length !== 0 && (
              <DataGrid
                rowKey="cteid"
                dataSource={state.finConElemSteps}
                titleComcode="steps"
                columns={columns}
              />
            )}
          </TabPane>
          <TabPane tab="ConElements" key={4} forceRender>
            <Collapse
              bordered={false}
              // defaultActiveKey={['1']}
              expandIcon={({ isActive }) => (
                <CaretRightOutlined
                  style={{ fontSize: 24 }}
                  rotate={isActive ? 90 : 0}
                />
              )}
              expandIconPosition="left"
            >
              {state.SERV.length !== 0 && (
                <Panel
                  header={
                    <Textc style={{ fontSize: 22, fontWeight: 'bold' }}>
                      <GetLabel label="SERV" />
                    </Textc>
                  }
                  key="1"
                  style={{
                    marginBottom: 24,
                    overflow: 'hidden',
                    background: '#f7f7f7',
                    border: 10,
                    borderRadius: 2,
                  }}
                >
                  <DataGrid
                    rowKey="cteid"
                    dataSource={state.SERV}
                    columns={columnsconE}
                  />
                </Panel>
              )}
              {state.FEES.length !== 0 && (
                <Panel
                  header={
                    <Textc style={{ fontSize: 22, fontWeight: 'bold' }}>
                      <GetLabel label="FEES" />
                    </Textc>
                  }
                  key="2"
                  style={{
                    marginBottom: 24,
                    overflow: 'hidden',
                    background: '#f7f7f7',
                    border: 10,
                    borderRadius: 2,
                  }}
                >
                  <DataGrid
                    rowKey="cteid"
                    dataSource={state.FEES}
                    columns={columnsconE}
                  />
                </Panel>
              )}
              {state.FINSERV.length !== 0 && (
                <Panel
                  header={
                    <Textc style={{ fontSize: 22, fontWeight: 'bold' }}>
                      <GetLabel label="FINSERV" />
                    </Textc>
                  }
                  key="3"
                  style={{
                    marginBottom: 24,
                    overflow: 'hidden',
                    background: '#f7f7f7',
                    border: 10,
                    borderRadius: 2,
                  }}
                >
                  <DataGrid
                    rowKey="cteid"
                    dataSource={state.FINSERV}
                    columns={columnsconE}
                  />
                </Panel>
              )}
              {state.COMM.length !== 0 && (
                <Panel
                  header={
                    <Textc style={{ fontSize: 22, fontWeight: 'bold' }}>
                      <GetLabel label="COMM" />
                    </Textc>
                  }
                  key="4"
                  style={{
                    marginBottom: 24,
                    overflow: 'hidden',
                    background: '#f7f7f7',
                    border: 10,
                    borderRadius: 2,
                  }}
                >
                  <DataGrid
                    rowKey="cteid"
                    dataSource={state.COMM}
                    columns={columnsconE}
                  />
                </Panel>
              )}
            </Collapse>
          </TabPane>
        </Tabs>
      </Spin>
    </DF.Provider>
  );
};
export default TabPrefinActivation;
